import { LegislativnyMaterialGetReportPripomienkyApi } from 'evidencna-aplikacia-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import Uuid from '../model/Uuid';
import { ClientResponse } from '../model/ClientResponse';
import { evidenciaPrefixPath } from './configuration/apiConfigurationConstants';
import { getFileName } from './exportClient';
import apiConfiguration from './configuration/apiConfiguration';

const client = new LegislativnyMaterialGetReportPripomienkyApi(apiConfiguration(evidenciaPrefixPath));

interface ReportResponse {
  fileName: string;
  blob: Blob;
}

// eslint-disable-next-line import/prefer-default-export
export const exportVznesenePripomienky = async (
  materialUuid: Uuid,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<ReportResponse>> => {
  const {
    data,
    status,
    headers,
  } = await client.getReportPripomienky(
    materialUuid,
    { ...options, responseType: 'blob' },
  );
  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);

  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
